/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import SlideOne from './SlideOne';
import SlideTwo from './SlideTwo';
import SlideThree from './SlideThree';
import './Carousel.css';
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import CurrentUserContext from '../../Contexts/userContexts';



function Carousel() {

    const { show } = useContext(CurrentUserContext)


    const slidesComponents = [<SlideOne />, <SlideTwo />, <SlideThree />]

    const [current, setCurrent] = useState(0);
    const length = slidesComponents.length;


    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1);
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);

    };



    let displayslide = slidesComponents[current]

    useEffect(() => {
        const interval = setInterval(nextSlide, 6000);

        if (show === true) {
            clearInterval(interval)
        }

        return () => clearInterval(interval);
    }, [current, show]);

    // if para parar o carossel quando se carrega no slide 1

    return (
        <>
            <div className='carouselContainer'>
                <AiOutlineLeft size={80} onClick={prevSlide} className='arrowLeft' />
                {displayslide}
                <AiOutlineRight size={80} onClick={nextSlide} className='arrowRight' />
            </div>
        </>
    );

}
export default Carousel